import {Component} from "react";
import config from 'config';

export default class ChatPopUp extends Component {
  componentDidMount(): void {
    if(document.readyState !== 'complete') {
      window.addEventListener('load', this.onWindowLoaded);
    } else {
      ChatPopUp.addScript();
    }
  }

  componentWillUnmount(): void {
    window.removeEventListener('load', this.onWindowLoaded);
  }

  private onWindowLoaded = () => {
    window.removeEventListener('load', this.onWindowLoaded);
    ChatPopUp.addScript();
  };

  private static addScript() {
    if(document.getElementById('hs-script-loader')) {
      return;
    }
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.id = 'hs-script-loader';
    s.async = true;
    s.defer = true;
    s.src = `//js.hs-scripts.com/${config.hubspot.appID}.js`;
    document.body.appendChild(s);
  }

  render() {
    return null;
  }
}
